import React from 'react'
import { Create } from 'react-admin'
import SectionWrapper from 'ui-shared/LayoutComponents/SectionWrapper'
import DrinkPackageForm from './DrinkPackageForm'

const DrinkPackageCreate: React.FC = () => (
  <SectionWrapper title={'resources.drinkpackages.createPackage'}>
    <Create>
      <DrinkPackageForm />
    </Create>
  </SectionWrapper>
)

export default DrinkPackageCreate
